module.exports = __webpack_public_path__ + "static/media/right-arrow.45cdf8c5.svg";